import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseModule from './BaseModule.vue'
import { useI18n } from 'vue-i18n'
import { useDeviceStore } from '@/store/deviceStore'
import { storeToRefs } from 'pinia'


export default /*@__PURE__*/_defineComponent({
  __name: 'MotionAnalyzerModule',
  setup(__props) {

const { t } = useI18n()
const deviceStore = useDeviceStore()
const { motorStatus } = storeToRefs(deviceStore)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModule, {
    installed: false,
    error: _unref(motorStatus).highTemperature,
    "content-active": 
      !_unref(motorStatus).overcurrent &&
      !_unref(motorStatus).stalled &&
      !_unref(motorStatus).highTemperature
    
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('modules.motionAnalyzer.index')), 1)
    ]),
    _: 1
  }, 8, ["error", "content-active"]))
}
}

})